import React, { useEffect, useRef, useState } from 'react'
import { Box, Typography } from "@mui/material"
import Renderer from '../../components/renderer';
import { getAnswerFromSelected, getMarks } from '../../utils'
import CorrectAnswer from '../../components/results/CorrectAnswer'
import Answer from '../../components/results/Answer'
import MatchTheFollowing from '../../components/quiz/MatchTheFollowing';
import { evaluateMTF } from '../../utils';
import Button from '../../components/Button';

const PreviewQuestion = ({ openPreview, question, handleClose }) => {

    const containerRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current) {
                const { scrollHeight, clientHeight } = containerRef.current;
                setIsOverflowing(scrollHeight > clientHeight);
            }
        };

        // Initial check
        checkOverflow();

        // Re-check on window resize
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, []);

    const selectedAnswer = []

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography
                    align="left"
                    variant="h1"
                    color="primary.blue"
                    sx={{
                        margin: '0',
                        fontWeight: '700',
                        lineHeight: '1.5',
                        fontSize: '2rem',
                    }}>{'Preview'}</Typography>
                <span style={styles.score} className={'scores ' + (question?.marks ? 'color-success' : 'color-wrong')}>{`Score ${question?.answerDetails?.options?.marks}`}</span>
            </Box>
            {isOverflowing && (question?.type == 'MTF') && (
                <Typography
                    variant="body2"
                    color="error"
                    sx={{
                        textAlign: "center",
                        backgroundColor: "rgba(255, 0, 0, 0.1)",
                        padding: "8px",
                        borderRadius: "4px",
                        margin: 1
                    }}
                >
                    Content exceeds the visible area. This will enable Scroll in Quiz.
                </Typography>
            )}
            <Box ref={containerRef} sx={{
                height: question?.type === "MTF" ? "calc(100vh - 300px)" : '100%',
                overflowY: "scroll",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'start'
            }}
            >
                <div>
                    <div style={styles.questionInnerContainer}>
                        {/* <span style={styles.question}>{questionDetails.text}</span> */}
                        <Renderer content={question?.questionDetails?.text} mediaStyle={{ height: '150px', width: 'auto' }}
                            contentUrl={question?.questionDetails.contentURL}
                            contentType={question?.questionDetails.style}
                            overrideHTML={question?.questionDetails.overrideHTML}
                            contentDisplayType={question?.type}
                            helpText={question?.answerDetails?.options?.helpText}
                            disabled={true}
                            enableTextToAudio={true}
                            templateType={question?.questionDetails.displayTemplate} />
                    </div>
                    <div>
                        <div className='grid-container'>
                            {question?.answerDetails?.options?.values && question?.answerDetails?.options?.values.length ? question?.answerDetails?.options?.values.map((ans, index) => {
                                // let { correct, wrong } = evaluate(question?.type, selectedAnswer, ans, question?.answerDetails?.options?.answerLabels);
                                return (
                                    <Answer className='grid-item' key={ans.label} label={ans.label} data={ans} content={ans.value.text} />
                                )
                            }) : (
                                <React.Fragment>
                                    {(() => {
                                        if (question?.type == 'MTF') {
                                            let left = question?.answerDetails.options?.MTFLHS;
                                            let right = question?.answerDetails.options?.MTFRHS;
                                            let evaluated = evaluateMTF(left, right, selectedAnswer, getMarks(question?.answerDetails));

                                            return (
                                                <MatchTheFollowing
                                                    disabled={true}
                                                    mode={'result'}
                                                    evaluated={true}
                                                    selectedAnswer={evaluated.ans}
                                                    left={evaluated.left}
                                                    right={evaluated.right}
                                                    helpText={question?.answerDetails?.options?.helpText}
                                                    quizPart={false}
                                                    enableTextToAudio={true}
                                                    preview={true}
                                                    questionId={question?.id}
                                                />
                                            );
                                        } else {
                                            let ans = getAnswerFromSelected(selectedAnswer);
                                            // let { correct, wrong } = evaluate(type, ans, null, answerLabels);

                                            return (
                                                <Answer
                                                    className='grid-item'
                                                    data={ans}
                                                    content={(Array.isArray(ans) ? ans : []).join('')}
                                                // wrong={wrong}
                                                // correct={correct}
                                                />
                                            );
                                        }
                                    })()}
                                </React.Fragment>
                            )}
                        </div>
                        {/* only show if the answer is wrong and not MTF */}
                        {question?.type != 'MTF' && (
                            <CorrectAnswer answerLabels={question?.answerDetails?.options?.answerLabels} type={question?.type} choices={question?.answerDetails?.options?.values} />
                        )}
                    </div>
                </div>
            </Box>
            <Button size='large' variant="contained" onClick={handleClose} color="primary" placeholder={'Back'} />
        </React.Fragment>
    )
}


const styles = {
    container: {
        border: 'none'
    },
    innerContainer: {
        background: 'var(--color-white)',
        borderRadius: '4px',
        margin: '0 auto',
        padding: '0 0 40px',
    },
    questionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '40px',
        height: 'calc(100vh - 300px)',
        // background: 'grey',
        overflowY: 'scroll'
    },
    questionInnerContainer: {
        // width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    questionNumber: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        margin: 0,
        marginRight: '18px',
        color: 'var(--color-black)',
    },
    question: {
        fontSize: 'clamp(16px, 5vw, 24px)',
        fontWeight: 500,
        lineHeight: 1.3,
        color: 'var(--color-black)',
        marginBottom: '20px',
    },
    renderer: {
        width: '90%',
        marginBottom: '40px',
        paddingLeft: '40px'
    },
    score: {
        fontWeight: 500,
        fontSize: '16px',
        marginTop: '4px',
    },
    retryContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '40px'
    },
    closeModal: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    }
}


export default PreviewQuestion;
